/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerAdmissionFlags200ResponseDataInner } from './FindAllScreenerAdmissionFlags200ResponseDataInner';
import {
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSONTyped,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON,
} from './FindAllScreenerAdmissionFlags200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllScreenerAdmissionFlags200Response
 */
export interface FindAllScreenerAdmissionFlags200Response {
    /**
     * 
     * @type {Array<FindAllScreenerAdmissionFlags200ResponseDataInner>}
     * @memberof FindAllScreenerAdmissionFlags200Response
     */
    data?: Array<FindAllScreenerAdmissionFlags200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllScreenerAdmissionFlags200Response interface.
 */
export function instanceOfFindAllScreenerAdmissionFlags200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerAdmissionFlags200ResponseFromJSON(json: any): FindAllScreenerAdmissionFlags200Response {
    return FindAllScreenerAdmissionFlags200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerAdmissionFlags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerAdmissionFlags200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON)),
    };
}

export function FindAllScreenerAdmissionFlags200ResponseToJSON(value?: FindAllScreenerAdmissionFlags200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON)),
    };
}

